

import React, { useEffect, useRef, useState } from "react";


///icons
import playIcons from "../assets/img/icons/play.png";
import pauseIcons from "../assets/img/icons/pause.png";
import volumeIcons from "../assets/img/icons/volume-high.png";
import fullSreenIcon from "../assets/img/icons/maximize-2.png";
import nextIcon from "../assets/img/icons/next.png";
import prevIcon from "../assets/img/icons/previous.png";
import {Slider } from "@mui/material";

import "./video.styles.scss";
import { fileBaseUrl } from "../core/services/baseUrl";


const VideoPlayer = ({ videoProps = {}, url = "", slideNext, slidePerv, videoPlayerRef }) => {

  const videoRef = useRef(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [volume, setVolume] = useState(1);

  const [showVolume, setShowVolume] = useState(false);
  const [currentTime, setCurrentTime] = useState("0:00");
  const [currentTimeSlider, setCurrentTimeSlider] = useState(0);
  const [durationSlider, setDurationSlider] = useState(0);
  const [duration, setDuration] = useState("0:00");
  //State
  const handlePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsVideoPlaying(true);
      } else {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      }
    }
  };

  const handleVolumeChange = (event) => {
    const newVolume = parseFloat(event.target.value);
    setVolume(newVolume);
    if (videoRef.current) {
      videoRef.current.volume = newVolume;
    }
  };

  useEffect(() => {
    setShowVolume(false);
  }, [isVideoPlaying]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${formattedSeconds}`;
  };

  const updateTime = () => {
    if (videoRef.current) {
      setCurrentTimeSlider(Math.floor(videoRef.current.currentTime));
      setDurationSlider(Math.floor(videoRef.current.duration));
      setCurrentTime(formatTime(videoRef.current.currentTime));
      setDuration(formatTime(videoRef.current.duration));
    }
  };

  const handleFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.requestFullscreen) {
        /* IE/Edge */
        videoRef.current.requestFullscreen();
      }
    }
  };

  const jumpToTime = (e, value) => {
    const time = parseFloat(e.target.value);
    setCurrentTimeSlider(time);
    setCurrentTime(formatTime(time));
    if (videoRef.current) {
      videoRef.current.currentTime = time;
    }
  };

  const nextTimeVideo = () => {
    if(slideNext) {
      slidePerv()
    }
  };
  const prevTimeVideo = () => {
    if(slideNext) {
      slideNext()
    }
  };

  return (
    <div className="position-relative video-content d-flex align-items-center justify-content-center">
      {!isVideoPlaying ? (
        <button className="play-button" onClick={handlePlay}>
          <img src={playIcons} width={24} height={24} />
        </button>
      ) : (
        <button className="play-button paused" onClick={handlePlay}>
          <img src={pauseIcons} width={24} height={24} />
        </button>
      )}

      <div
        className={`buttom-content-video w-100 d-flex flex-column ${
          !isVideoPlaying && " paused"
        }`}
      >
        <div className="mb-3">
          <div dir="ltr" className="px-1 " style={{ marginBottom: "-8px" }}>
            <Slider
              aria-label="time-indicator"
              size="small"
              value={Number(currentTimeSlider)}
              min={0}
              step={1}
              style={{ color: "#FF7E7E" }}
              max={durationSlider}
              onChange={(e, value) => jumpToTime(e, value)}
            />
          </div>
          <div className=" w-100 d-flex align-items-center justify-content-between">
            <div onClick={handleFullscreen}>
              <img src={fullSreenIcon} width={24} height={24} />
            </div>
            <div className="current-time">
              <span className="text-white">{currentTime}</span>
            </div>
            <div className="d-flex align-items-center">
              <div onClick={nextTimeVideo}>
                <img src={prevIcon} width={24} height={24} />
              </div>
              <div className="mx-2" onClick={handlePlay}>
                {!isVideoPlaying ? (
                  <img src={playIcons} width={24} height={24} />
                ) : (
                  <img src={pauseIcons} width={24} height={24} />
                )}
              </div>
              <div onClick={prevTimeVideo}>
                <img src={nextIcon} width={24} height={24} />
              </div>
            </div>
            <div className="current-time">
              <span className="text-white">{duration}</span>
            </div>
       
            <div className="volume-content position-relative">
              <div onClick={() => setShowVolume(!showVolume)}>
                <img src={volumeIcons} width={24} height={24} />
              </div>
              {showVolume && (
                <input
                  dir="ltr"
                  type="range"
                  min="0"
                  max="1"
                  step="0.1"
                  value={volume}
                  onChange={handleVolumeChange}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <video
      
        onTimeUpdate={updateTime}
        onClick={handlePlay}
        ref={videoRef}
        controls={false}
        className="w-100"
        onPlay={videoProps.onPlay}
        onEnded={() => {
          videoProps?.onEnded()
          setIsVideoPlaying(false)}}
      >
        <source src={fileBaseUrl + url} />
      </video>
    </div>
  );
};

export default VideoPlayer;






// import React, { useState, useEffect } from "react";
// import { useRef } from "react";
// import {
//   Player,
//   LoadingSpinner,
//   BigPlayButton,
//   ControlBar,
//   ForwardControl,
//   VolumeMenuButton,
//   PlaybackRateMenuButton,
// } from "video-react";
// import "video-react/dist/video-react.css";
// import useVisibilityChange from "../core/custom-hooks/useVisibilityChange.hook";
// import { fileBaseUrl } from "../core/services/baseUrl";
// ///////
// const VideoPlayer = ({ videoProps = {}, url = "" }) => {
//   const videoPlayerRef = useRef();
//   useVisibilityChange({
//     onHide: () => {
//       videoPlayerRef.current.actions.pause();
//     },
//   });

//   console.log(videoProps);

//   return (
//     <Player
//       ref={videoPlayerRef}
//       muted={false}
//       width="100%"
//       height={"auto"}
//       {...videoProps}
//     >
//       <source src={fileBaseUrl + url} />
//       <LoadingSpinner />
//       <BigPlayButton position="center" />
//       <ControlBar autoHide={false}>
//         <VolumeMenuButton vertical order={3.1} />
//         {/* <ForwardControl seconds={5} order={3.2} /> */}
//         {/* <PlaybackRateMenuButton rates={[2, 1, 0.5]} /> */}
//       </ControlBar>
//     </Player>
//   );
// };

// export default VideoPlayer;
